import { render, staticRenderFns } from "./suporte-convites.vue?vue&type=template&id=5942168c&scoped=true"
import script from "./suporte-convites.vue?vue&type=script&lang=ts"
export * from "./suporte-convites.vue?vue&type=script&lang=ts"
import style0 from "./suporte-convites.vue?vue&type=style&index=0&id=5942168c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942168c",
  null
  
)

export default component.exports